import styled from 'styled-components';

import checkIcon from 'app/assets/leads/icon-check.svg';
import closeIcon from 'app/assets/leads/icon-x-close.svg';

type ProfileStatusIconProps = {
  variant: 'complete' | 'incomplete';
};

const IconFrame = styled.span<{ $variant: ProfileStatusIconProps['variant'] }>`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: ${({ theme: { spacing } }) => spacing(7)};
  height: ${({ theme: { spacing } }) => spacing(7)};
  border-radius: 50%;
  background: ${({ theme, $variant }) => ($variant === 'complete' ? theme.semantic.success_400 : theme.semantic.error_500)};
  color: ${({ theme }) => theme.semantic.text_small_elements};
`;

const Glyph = styled.span<{ $icon: string }>`
  width: ${({ theme: { spacing } }) => spacing(4)};
  height: ${({ theme: { spacing } }) => spacing(4)};
  background: currentColor;
  -webkit-mask: ${({ $icon }) => `url(${$icon}) center / contain no-repeat`};
  mask: ${({ $icon }) => `url(${$icon}) center / contain no-repeat`};
`;

export const ProfileStatusIcon = ({ variant }: ProfileStatusIconProps) => (
  <IconFrame $variant={variant} aria-hidden="true">
    <Glyph $icon={variant === 'complete' ? checkIcon : closeIcon} />
  </IconFrame>
);

export default ProfileStatusIcon;
